module.exports = __webpack_public_path__ + "img/chat.ae142011.svg";